module.exports = __webpack_public_path__ + "img/9.8620b15b.png";